"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyConditionExprSchema = exports.ConditionGroupSchema = exports.ConditionSchema = exports.AggregateTypeSchema = exports.OperatorSchema = void 0;
const zod_1 = require("zod");
exports.OperatorSchema = zod_1.z.enum([
    'gt',
    'gte',
    'lt',
    'lte',
    'in',
    'nin',
    'eq',
    'neq',
]);
exports.AggregateTypeSchema = zod_1.z.enum([
    'sum',
    'average',
    'count',
    'distribution',
    'percentile',
]);
exports.ConditionSchema = zod_1.z.object({
    key: zod_1.z.string(),
    operator: exports.OperatorSchema,
    value: zod_1.z.unknown(),
    aggregate: exports.AggregateTypeSchema.optional(),
});
exports.ConditionGroupSchema = zod_1.z.object({
    mode: zod_1.z.enum(['and', 'or']),
    conditions: zod_1.z.array(exports.ConditionSchema),
});
exports.AnyConditionExprSchema = zod_1.z.union([exports.ConditionSchema, exports.ConditionGroupSchema]);
//# sourceMappingURL=conditionSchema.js.map